(function() {
  var tabletMediaQuery = window.matchMedia('(max-width: 66emem)');
  var selectorSuffix = '-collection-selector';

  function getSectionFromFilterInput(input) {
    if (!input) return null;
    var name = input.getAttribute('name');
    if (name && name.slice(-selectorSuffix.length) === selectorSuffix) {
      var sectionId = name.slice(0, name.length - selectorSuffix.length);
      var section = document.getElementById('shopify-section-' + sectionId);
      if (section) return section;
    }
    return input.closest('[id^="shopify-section-"]') || input.closest('.product-tabs');
  }

  function getTabBgMap(section) {
    var jsonEl = section.querySelector('[data-tab-backgrounds-json]');
    if (!jsonEl) return {};
    try {
      return JSON.parse(jsonEl.textContent);
    } catch (error) {
      return {};
    }
  }

  function getBgImageUrl(entry) {
    if (!entry) return '';
    var desktop = entry.desktop;
    var mobile = entry.mobile;
    var url = tabletMediaQuery.matches ? (mobile || desktop) : (desktop || mobile);
    return url || '';
  }

  function updateTabBackground(section, collectionHandle) {
    var display = section.querySelector('.tab-background-display');
    if (!display) return;
    var entry = getTabBgMap(section)[collectionHandle];
    var url = getBgImageUrl(entry);
    display.style.backgroundImage = url ? 'url(' + url + ')' : '';
  }

  function getFilterKey(section) {
    var slide = section.querySelector('.keen-slider-slide, .grid-item');
    if (!slide) return 'collection';
    if (slide.dataset.tab !== undefined) return 'tab';
    if (slide.dataset.collection !== undefined) return 'collection';
    return 'collection';
  }

  function getSlideSelector(section) {
    return section.querySelector('.grid-item') ? '.grid-item' : '.keen-slider-slide';
  }

  function getActiveFilterValue(section) {
    var checked = section.querySelector('input[name$="-collection-selector"]:checked');
    if (checked) return checked.value;
    var select = section.querySelector('select[name$="-collection-selector"]');
    return select ? select.value : '';
  }

  function showSlidesForValue(section, value) {
    if (!section || !value) return;
    var filterKey = getFilterKey(section);
    var slideSelector = getSlideSelector(section);
    section.querySelectorAll(slideSelector).forEach(function(slide) {
      slide.style.display = slide.dataset[filterKey] === value ? '' : 'none';
    });
    var carousel = section.querySelector('component-carousel');
    if (carousel && carousel.sliderObj) {
      carousel.sliderObj.refresh();
    }
    updateTabBackground(section, value);
  }

  function initSection(section) {
    if (!section || !section.querySelector('.tab-background-display')) return;
    updateTabBackground(section, getActiveFilterValue(section));
  }

  function handleFilterChange(e) {
    var input = e.target;
    if (!input.matches('input[name$="-collection-selector"], select[name$="-collection-selector"]')) return;
    var section = getSectionFromFilterInput(input);
    if (!section) return;
    showSlidesForValue(section, input.value);
  }

  document.addEventListener('change', handleFilterChange);
  document.addEventListener('input', handleFilterChange);
  document.addEventListener('click', function(e) {
    var label = e.target.closest('.collection-item.util-tab-wrap label[for]');
    if (!label) return;
    var input = document.getElementById(label.getAttribute('for'));
    if (!input || !input.matches('input[name$="-collection-selector"]')) return;
    window.requestAnimationFrame(function() {
      if (input.checked) handleFilterChange({ target: input });
    });
  });

  tabletMediaQuery.addEventListener('change', function() {
    document.querySelectorAll('[id^="shopify-section-"]').forEach(function(section) {
      if (section.querySelector('[data-tab-backgrounds-json]')) {
        initSection(section);
      }
    });
  });

  function initAll(root) {
    (root || document).querySelectorAll('[id^="shopify-section-"]').forEach(function(section) {
      if (section.querySelector('[data-tab-backgrounds-json]')) {
        initSection(section);
      }
    });
  }

  initAll();

  document.addEventListener('shopify:section:load', function(e) {
    initAll(e.target);
  });

  
})();
